import { defineComponent, ref } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { ArrowLeftBold } from '@element-plus/icons';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'FindBike',
    components: {
        BaseLayout: BaseLayout,
        ArrowLeftBold: ArrowLeftBold,
    },
    setup: function () {
        var isShowBikeLand = ref(false);
        // const currentPosition = ref<ILatLngLiteral | null>(null);
        var nearByTourismInfo = ref([]);
        var router = useRouter();
        // const getLocation = async() => {
        // if (navigator.geolocation) {
        //   console.log('GPS')
        //     await navigator.geolocation.getCurrentPosition(showPosition);
        //   }
        // };
        // const showPosition = (position: any) => {
        //   const { latitude, longitude } = position.coords;
        //   currentPosition.value = {
        //     lat: latitude,
        //     lng: longitude,
        //   };
        //   console.log(currentPosition.value)
        //   // currentPosition.value = { lat: 25.0325917, lng: 121.5624999 };
        // };
        // const searchedStationInfo = () => {
        //   try {
        //     const res = await bikeHandler.getOneStationInfo()
        //   } catch(error) {
        //     console.log(error);
        //   }
        // }
        // const onSearch = async() => {
        //   const search
        // };
        // const getNearByScenics = async(currentPosition: ILatLngLiteral) => {
        //   const {lat, lng} = currentPosition;
        //   const res = await tourismHandler.getNearbyScenicSpots(lat, lng);
        //   nearByTourismInfo.value = res.data;
        // };
        // const getNearbyRestaurants = async(currentPosition: ILatLngLiteral) => {
        //   const {lat, lng} = currentPosition;
        //   const res = await tourismHandler.getNearbyRestaurants(lat, lng);
        //   nearByTourismInfo.value = res.data;
        // }
        // const searchTourism = () => {
        //   if (!currentPosition.value) return;
        //   if (searchType.value === 'Spot') {
        //     getNearByScenics(currentPosition.value);
        //   }
        //   if (searchType.value === 'Food') {
        //     getNearbyRestaurants(currentPosition.value)
        //   }
        // };
        var getDetail = function () {
            router.push({ name: 'ScenicFoodInfoDetail' });
        };
        // watch(() => currentPosition.value, () => {
        //   searchTourism();
        // });
        // watch(() => searchType.value, () => {
        //   searchTourism();
        // });
        // onMounted(async() => {
        //   console.log('start')
        //   await getLocation();
        //   console.log('cuuu', currentPosition.value)
        //   if (currentPosition.value) {
        //     getNearByScenics(currentPosition.value);
        //   }
        // });
        // onMounted(() => {
        //   info.
        // });
        var goBack = function () {
            router.back();
        };
        return {
            isShowBikeLand: isShowBikeLand,
            // currentPosition,
            nearByTourismInfo: nearByTourismInfo,
            // getLocation,
            getDetail: getDetail,
            goBack: goBack,
        };
    },
});
